/**
 * Compact pill showing how many units and criteria a cycle currently holds.
 */
import React from "react";
import { translateUi } from "../i18n/index";
import { cbCn } from "./cycleBuilderTheme";

export function CycleCountsBadge({
  units,
  criteria,
  isDarkMode = false,
}: {
  units: number;
  criteria: number;
  isDarkMode?: boolean;
}) {
  return (
    <span
      className={cbCn(
        "inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold tabular-nums shadow-sm",
        isDarkMode
          ? "border-indigo-500/40 bg-indigo-950/60 text-indigo-100"
          : "border-indigo-200 bg-indigo-50 text-indigo-800"
      )}
      title={translateUi("Units and criteria on this cycle")}
    >
      <span>
        {units} {units === 1 ? translateUi("unit") : translateUi("units")}
      </span>
      <span className={isDarkMode ? "text-indigo-400" : "text-indigo-300"} aria-hidden>
        ·
      </span>
      <span>
        {criteria} {criteria === 1 ? translateUi("criterion") : translateUi("criteria")}
      </span>
    </span>
  );
}
